export default "__VITE_ASSET__YHp0MvQG__"